import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import "./globals.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { QueryClient } from "@tanstack/react-query";
import { AppContextProvider } from "./components/Context";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import AuthManager from "./auth/AuthManager";
import { LocalStorageKeys } from "./utils/localStorageKeys";

// const persistCacheToLocalStorage = (cache) => {
//   localStorage.setItem('react-query-cache', JSON.stringify(cache));
// };

// const hydrateCacheFromLocalStorage = () => {
//   const cacheData = localStorage.getItem('react-query-cache');
//   if (cacheData) {
//     return JSON.parse(cacheData);
//   }
//   return {};
// };
localStorage.setItem(LocalStorageKeys.locationPromptShown, "false");
export const authManager = AuthManager.fromStorageOrDefault() as AuthManager;
const persister = createSyncStoragePersister({
  storage: localStorage,
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60 * 60 * 1000 * 24,
      networkMode: "always",
    },
  },
});

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister }}
      >
        <AppContextProvider>
          <RouterProvider router={router} />{" "}
          {/* I need to change the icon position to top*/}
          <ReactQueryDevtools initialIsOpen={false} position="bottom" />
        </AppContextProvider>
      </PersistQueryClientProvider>
    </StrictMode>
  );
}

if (
  "serviceWorker" in navigator &&
  process.env.VITE_NODE_ENV !== "development"
) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/serviceWorker.js")
      .then((registration) => {
        if (navigator.onLine) {
          registration.update();
        }

      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  });
}
